import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Flowbite, Carousel } from "flowbite-react";

// The site's dots (Ui::Dots): 8px, the active one stretched to a 24px bar.
const customTheme = {
  indicators: {
    active: {
      off: "w-2 bg-white/70 hover:bg-white",
      on: "w-6 bg-default-600",
    },
    base: "h-2 rounded-full transition-all duration-300",
    wrapper: "absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-2",
  },
};

function ImagesCarousel({ images = [], useIndicators }) {
  return (
    <Flowbite theme={{ theme: customTheme }}>
      <Carousel slideInterval={5000} indicators={useIndicators}>
        {images.map((img) => (
          <div className="flex h-full items-center justify-center bg-gray-400 dark:bg-gray-700 dark:text-white">
            <img key={img.url} src={img.url} alt={img.description} />
          </div>
        ))}
      </Carousel>
    </Flowbite>
  );
}

export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);
    const useIndicators =
      this.element.dataset.indicators === "false" ? false : true;
    const images = this.element.dataset.images
      ? JSON.parse(this.element.dataset.images)
      : [];
    this.root.render(
      <ImagesCarousel useIndicators={useIndicators} images={images} />,
    );
  }
}
